module.exports = __webpack_public_path__ + "img/logo-normal.4c2d9495.png";